









































































































































import { Component, Vue } from "vue-property-decorator";
import SmallCard from "./components/smallCard.vue";
import Contact from "./components/contact.vue";
import vueSeamlessScroll from "./components/myClass.vue";
import { getCooperationList } from "@/req/homes";

@Component({
  components: {
    SmallCard,
    Contact,
    vueSeamlessScroll,
  },
})
export default class Home extends Vue {
  public typeList = {
    1: '买量联运',
    2: '公会联运',
    3: '硬核联运',
  }
  public listData = [];
  public optionData = {
    limitMoveNum: 5,
    switchSingleStep: 130,
    direction: 3,
    switchOffset: 0,
    autoPlay: true,
    navigation: true,
  };
  public checkAll(event) {
    if (event) {
      if (event.target.id) {
        window.open("/contactExample", "_blank");
      }
    }
  }
  /**
   * initCooperationList
   */
  public async initCooperationList() {
    const res = await getCooperationList()
    if (res.code === 200) {
      this.listData = res.data;
    }
  }
  /**
   * mounted
   */
  public mounted() {
    this.initCooperationList()
  }
}
